module.exports = __webpack_public_path__ + "img/中国农业银行_金融服务列表.d600454c.png";